import Card from "../UI/Card";
import Title from "../UI/Title";
import Text from "../UI/Text";
import Button from "../UI/Button";
// @ts-expect-error pure js
import { COMPTA_PRICE } from "../../utils/constants/compta.js";
import styles from "./FiscaliteNoSubscription.module.css";

interface FiscaliteNoSubscriptionProps {
  fiscalYears: number[];
  onSubscribe: (year: number) => void;
}

const STEPS = [
  {
    title: "Sélectionnez votre bien",
    description:
      "Choisissez l'année pour laquelle vous souhaitez effectuer votre déclaration. Si vous souhaitez souscrire pour un rattrapage sur une année antérieure, contactez nous !",
  },
  {
    title: "Sélectionnez les biens à déclarer",
    description:
      "Choisissez le ou les biens pour lesquels vous souhaitez réaliser vos déclarations fiscales. Si vous détenez un immeuble, il est possible, sous certaines conditions, de faire une déclaration consolidée et de considérer l’immeuble entier comme « un seul bien ».",
    moreInfoUrl: "https://www.qalimo.fr/comptabilite-lmnp/",
  },
  {
    title: "Remplissez votre déclaration avec l'aide de Qalimo",
    description:
      "Qalimo vous guide à travers un formulaire simple pour compléter les informations nécessaires et remplir votre déclaration fiscale.",
  },
  {
    title: "Suivez l'avancement de votre déclaration",
    description:
      "Suivez facilement l'état d'avancement de votre déclaration directement depuis votre espace.",
  },
];

export default function FiscaliteNoSubscription({
  fiscalYears,
  onSubscribe,
}: FiscaliteNoSubscriptionProps) {
  return (
    <div className={styles.wrapper}>
      <Title as="h2" variant="deca" weight="bold">
        Réalisez vos déclarations fiscales facilement avec Qalimo
      </Title>

      <div className={styles.steps}>
        {STEPS.map((step, index) => (
          <div key={index} className={styles.step}>
            <div className={styles.stepHeader}>
              <Text
                as="div"
                weight="bold"
                color="white"
                className={styles.stepNumber}
              >
                {index + 1}
              </Text>
              <Text variant="base" weight="bold">
                {step.title}
              </Text>
            </div>
            <Text>
              {step.description}
              {step.moreInfoUrl && (
                <>
                  {" "}
                  <a href={step.moreInfoUrl} target="_blank">
                    En savoir plus
                  </a>
                </>
              )}
            </Text>
          </div>
        ))}
      </div>

      <Card padding="md" className={styles.assistanceCard}>
        <div className={styles.assistanceTopRow}>
          <div>
            <Title
              as="h3"
              variant="deca"
              weight="bold"
              className={styles.assistanceTitle}
            >
              Assistance déclaration fiscale
            </Title>
            <Text>
              Confiez votre déclaration à un expert et concentrez-vous sur
              l'essentiel. Une gestion précise, optimisée et 100 % sécurisée.
            </Text>
          </div>
          <div>
            <Text variant="deci">À partir de</Text>
            <div>
              <Text
                as="span"
                variant="mega"
                weight="bold"
                className={styles.priceAmount}
              >
                {COMPTA_PRICE}
              </Text>
              <Text as="span" variant="deci">
                € TTC
              </Text>
            </div>
          </div>
        </div>
        <div className={styles.actions}>
          <Button
            variant="secondary"
            onClick={() =>
              window.open("https://www.qalimo.fr/comptabilite-lmnp/", "_blank")
            }
          >
            En savoir plus
          </Button>
          {fiscalYears.map((year) => (
            <Button key={year} onClick={() => onSubscribe(year)}>
              {fiscalYears.length > 1
                ? `Souscrire pour ${year + 1}`
                : "Souscrire à l'offre"}
            </Button>
          ))}
        </div>
      </Card>
    </div>
  );
}
